import React, { useMemo } from 'react';

// FancyYool palette — un color de identidad por stage
const STAGE_GRADIENTS = {
  vistas:          'from-[#5B2BE5] via-[#7D7CFF] to-[#5B2BE5]',      // violet → indigo
  sesiones:        'from-[#2563EB] via-[#06b6d4] to-[#2563EB]',      // blue → cyan
  simulaciones:    'from-[#0ea5e9] via-[#06b6d4] to-[#147d89]',      // sky → cyan → lime
  contrataciones:  'from-[#7D7CFF] via-[#a855f7] to-[#7D7CFF]',     // indigo → purple
  suscripciones:   'from-[#007D6E] via-[#147d89] to-[#007D6E]',     // teal → lime
  certificados:    'from-[#E91E63] via-[#a855f7] to-[#5B2BE5]',     // pink → purple → violet
};

const WalletStageCard = ({
  stageKey,
  title,
  subtitle,
  value,
  rateText,
  growth,
  isPrimary,
  isExpanded,
  onPress,
  instructionText = 'Toca de nuevo para ver detalle'
}) => {
  const gradient = STAGE_GRADIENTS[stageKey] || 'from-[#5B2BE5] via-[#7D7CFF] to-[#5B2BE5]';

  // Crecimiento semanal
  const growthFormatted = useMemo(() => {
    if (growth === undefined || growth === null) return null;
    const isPositive = growth >= 0;
    return {
      value: `${Math.abs(growth).toFixed(1)}%`,
      icon: isPositive ? '↑' : '↓',
      color: isPositive ? 'text-green-300' : 'text-red-300',
    };
  }, [growth]);

  return (
    <button
      type="button"
      onClick={onPress}
      aria-expanded={Boolean(isExpanded)}
      className={`w-full text-left rounded-[22px] border border-white/10 bg-gradient-to-br ${gradient} shadow-[0_10px_30px_rgba(0,0,0,0.30)] active:scale-[0.995] transition-all duration-200 overflow-hidden`}
    >
      <div
        className={`${isExpanded ? 'px-6 pt-5 pb-5' : 'px-5 pt-4 pb-4'} aspect-[1.586] flex flex-col justify-between`}
        style={{ WebkitTapHighlightColor: 'transparent' }}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="text-[24px] font-bold text-white truncate tracking-tight leading-snug">{title}</div>
            {isExpanded && subtitle
              ? <div className="text-[15px] text-white/75 mt-1 leading-snug font-medium">{subtitle}</div>
              : null}
          </div>
          <div className="text-right">
            <div className="text-[40px] font-extrabold text-white leading-none tabular-nums tracking-tight drop-shadow-md">{value}</div>
          </div>
        </div>

        {/* Center KPIs */}
        {isExpanded && (
          <div className="flex-1 flex flex-col justify-center items-center py-2">
            <div className="flex flex-col items-center gap-3 w-full">
              {rateText && (
                <div className="flex flex-col items-center">
                  <span className="text-[42px] font-extrabold text-white leading-none tracking-tight drop-shadow-sm">{rateText}</span>
                  <span className="text-[14px] text-white/70 mt-1 uppercase tracking-wider font-semibold text-center">
                    {stageKey === 'sesiones' ? 'Tasa de rebote' : 'Conversión'}
                  </span>
                </div>
              )}

              {rateText && growthFormatted && <div className="w-16 h-[1px] bg-white/15 my-2" />}

              {growthFormatted && (
                <div className={`flex items-center gap-2 ${growthFormatted.color} bg-black/20 px-4 py-2 rounded-full backdrop-blur-md border border-white/10`}>
                  <span className="text-[16px] font-bold">{growthFormatted.icon} {growthFormatted.value}</span>
                  <span className="text-[12px] opacity-90 font-medium text-white/80">semana</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Footer */}
        {isExpanded && (
          <div className="mt-auto pt-4">
            <div className="h-[1px] bg-white/10" />
            <div className="mt-4 flex items-center justify-between gap-3">
              <div className="text-[13px] text-white/75 font-medium">{instructionText}</div>
              <div className="px-4 py-2 rounded-full bg-white/20 hover:bg-white/30 transition-colors text-[13px] font-bold text-white flex items-center gap-2 border border-white/10">
                Ver detalle
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>
    </button>
  );
};

export default WalletStageCard;
